import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "info-page-content" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('notFound.error')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("img", {
        class: "switch",
        src: _ctx.getImagePathByID('features', 'excalibur'),
        alt: "excalibur"
      }, null, 8, _hoisted_4),
      _createVNode(_component_v_btn, {
        size: "x-large",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'lobby' })))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('notFound.switch')), 1)
        ]),
        _: 1
      })
    ])
  ]))
}